import { render, staticRenderFns } from "./AgreementVersionsManage.vue?vue&type=template&id=3530b955&scoped=true"
import script from "./AgreementVersionsManage.vue?vue&type=script&lang=js"
export * from "./AgreementVersionsManage.vue?vue&type=script&lang=js"
import style0 from "./AgreementVersionsManage.vue?vue&type=style&index=0&id=3530b955&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3530b955",
  null
  
)

export default component.exports